import React from 'react';

const Skillsme = () => {
    return (
        <div className="skillss">

            <h1 className="skillsh1">My Skills</h1>

            <p className="headp">HTML</p>
            <div class="containerr">
                <div class="skills html"><span className="span11">98%</span></div>
            </div>

            <p className="headp">CSS</p>
            <div class="containerr">
                <div class="skills css"><span className="span11">95%</span></div>
            </div>

            <p className="headp">JavaScript</p>
            <div class="containerr">
                <div class="skills js"><span className="span11">90%</span></div>
            </div>
            <p className="headp">bootstrap</p>
            <div class="containerr">
                <div class="skills bootstrap"><span className="span11">90%</span></div>
            </div>
            <p className="headp">react js</p>
            <div class="containerr">
                <div class="skills react"><span className="span11">85%</span></div>
            </div>
            <p className="headp">node js</p>
            <div class="containerr">
                <div class="skills node"><span className="span11">83%</span></div>
            </div>
            <p className="headp">Express js</p>
            <div class="containerr">
                <div class="skills express"><span className="span11">84%</span></div>
            </div>
            
            <p className="headp">MongoDb</p>
            <div class="containerr">
                <div class="skills mongodb"><span className="span11">81%</span></div>
            </div>
            <h1 className="skillsh1">For site deployment</h1>
            <p className="headp">Github</p>
            <div class="containerr">
                <div class="skills git"><span className="span11">100%</span></div>
            </div>
            <p className="headp">Firebase</p>
            <div class="containerr">
                <div class="skills firebase"><span className="span11">100%</span></div>
            </div>
            <p className="headp">Netlify</p>
            <div class="containerr">
                <div class="skills netlify"><span className="span11">100%</span></div>
            </div>
            <p className="headp">heroku</p>
            <div class="containerr">
                <div class="skills heroku"><span className="span11">100%</span></div>
            </div>
        </div>
    );
};

export default Skillsme;